import { render, staticRenderFns } from "./gifts-card-modal.vue?vue&type=template&id=20293e4c&"
import script from "./gifts-card-modal.vue?vue&type=script&lang=js&"
export * from "./gifts-card-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports